module.exports = __webpack_public_path__ + "static/media/Products (8).c93c5558.png";